import React from 'react';
import { useTranslation } from 'react-i18next';
import viamericasLogo from '../assets/images/viamericas.svg';
import './Header.scss';

const Header = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  const currentLanguage = i18n.language || 'es';

  return (
    <header className="app-header">
      <div className="app-header__container">
        <div className="app-header__logo">
          <img src={viamericasLogo} alt="Viamericas" />
        </div>
        
        <div className="app-header__language">
          <button
            className={`language-btn ${currentLanguage === 'en' ? 'active' : ''}`}
            onClick={() => changeLanguage('en')}
            aria-label="Switch to English"
          >
            EN
          </button>
          <span className="language-separator">|</span>
          <button
            className={`language-btn ${currentLanguage === 'es' ? 'active' : ''}`}
            onClick={() => changeLanguage('es')}
            aria-label="Cambiar a Español"
          >
            ES
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
